import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { countBy } from 'lodash';
import moment from 'moment';
import VerbHeading from '../../../shared/components/VerbHeading';
import Image from '../../../shared/components/Image';
import VerbText from '../../../shared/components/VerbText';
import VerbButton from '../../../shared/components/VerbButton';
import { DEFAULT_IMAGE_URLS } from '../../../shared/Constants';

const NextPathwayMilestoneSection = (props) => {
    const _sendToNextCollection = () => {
        const { history, nextMilestone } = props;
        history.push(`/collection/${nextMilestone.permalink || nextMilestone._id}/path`);
    };

    const _sendToPathwayPanel = () => {
        const { history, currentPathwayId, nextMilestone } = props;
        history.push(`/home?pathwayView=myPathway&userPathwayId=${currentPathwayId}&forceOpenPanel=true`);
    };

    const { nextMilestone = {}, currentPathwayMilestones = [], currentPathwayName, handleClickPathway } = props;
    const { true: completedMilestonesCount } = countBy(currentPathwayMilestones, (item) => item.status === 'COMPLETED');
    const progressTracker = [];
    progressTracker.length = currentPathwayMilestones.length;

    for (let i = 0; i < currentPathwayMilestones.length; i += 1) {
        progressTracker[i] =
            i < completedMilestonesCount ? (
                <i key={i} className={'fas fa-circle collection-circle complete-collection-circle'}></i>
            ) : (
                <i key={i} className={'fas fa-circle collection-circle incomplete-collection-circle'}></i>
            );
    }

    let nextCardThumbnail = (
        <div className={'col-6 next-collection-image-container'}>
            <Image src={(nextMilestone && nextMilestone.thumbnailImageUrl) || ''} dimension={{ h: 160, w: 160 }} />
        </div>
    );
    let nextCardButton = {
        textId: 'BUTTON_KEEP_LEARNING',
        defaultMessage: 'KEEP LEARNING',
        onClick: _sendToNextCollection
    };
    let nextCardTitle = nextMilestone && nextMilestone.name;
    let dateTimeFormat = 'MMM Do - hh:mm a';
    if (nextMilestone && nextMilestone.type === 'TASK') {
        dateTimeFormat = 'MMM Do';
    }
    if (nextMilestone && nextMilestone.dateTime) {
        nextCardThumbnail = null;
        const formattedDateTime = moment(nextMilestone.dateTime).utc().format(dateTimeFormat);
        nextCardTitle = `${nextMilestone.name} on ${formattedDateTime}`;
        nextCardButton = {
            textId: 'BUTTON_SEE_MY_PATHWAY',
            defaultMessage: 'SEE MY PATHWAY',
            onClick: _sendToPathwayPanel
        };
    }
    return (
        <>
            <div className={'container next-collection-pathway'}>
                <div className={'row'}>
                    <div className={'col-sm-8 col-6 offset-2 col-lg-6 offset-lg-0'}>
                        <VerbHeading
                            className={'section-heading next-collection-pathway-header'}
                            hNumber={4}
                            messageId={'CONTINUE_PATHWAY'}
                            defaultMessage={'Continue On Your Pathway'}
                        />
                        <div className={'progress-tracker-circles'}>{progressTracker}</div>
                        <div className={'row'}>
                            <div className={'col-sm-4 col-md-3 col-3'}>
                                <Image
                                    src={DEFAULT_IMAGE_URLS.LEARNING_PATHWAY_HERBIE_FLAG}
                                    dimension={{ h: 100, w: 100 }}
                                    alt={'herbieContinueImage'}
                                />
                            </div>
                            <div className={'col-sm-5 col-12 col-lg-5 next-collection-pathway-text'}>
                                <VerbText
                                    messageId={'COLLECTION_PATHWAY_INTERSTITIAL_UP_NEXT_TEXT'}
                                    defaultMessage={
                                        'You’ve completed {MilestoneCount} out of {AllMilestonesCount} milestones in this pathway, {PathwayName}, Keep up the great work!'
                                    }
                                    valuesToInject={{
                                        MilestoneCount: completedMilestonesCount,
                                        AllMilestonesCount: currentPathwayMilestones.length || 0,
                                        PathwayName: (
                                            <span className={'verb-link'} onClick={handleClickPathway}>
                                                {currentPathwayName || ''}
                                            </span>
                                        )
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div
                        className={
                            'next-collection-container col-12 offset-2 offset-sm-2 col-lg-6 offset-lg-0 offset-xl-1'
                        }
                    >
                        {nextCardThumbnail}
                        <div
                            className={`${
                                nextMilestone && nextMilestone.dateTime ? 'col-12' : 'col-6'
                            } collection-details`}
                        >
                            <VerbHeading
                                className={'up-next-label'}
                                messageId={'ASSET_INTERSTITIAL_UP_NEXT'}
                                hNumber={6}
                                defaultMessage={'UP NEXT'}
                            />
                            <h4 className={'collection-title'}>{nextCardTitle}</h4>
                            <VerbButton
                                textId={nextCardButton.textId}
                                defaultMessage={nextCardButton.defaultMessage}
                                onClick={nextCardButton.onClick}
                                className={'collection-interstitial-button'}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export const NextPathwayMilestoneSectionComponent = NextPathwayMilestoneSection;

NextPathwayMilestoneSection.propTypes = {
    nextMilestone: PropTypes.object,
    currentPathwayMilestones: PropTypes.array,
    history: PropTypes.object,
    currentPathwayId: PropTypes.string,
    currentPathwayName: PropTypes.string,
    handleClickPathway: PropTypes.func
};

export default withRouter(NextPathwayMilestoneSection);
